var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00B0F5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.488.212a.724.724 0 0 1 1.024 0l2.73 2.731A.724.724 0 0 1 9.22 3.967L7.724 2.472v7.907a.724.724 0 1 1-1.448 0V2.472L4.78 3.967a.724.724 0 0 1-1.024-1.024l2.73-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.276 6.276c-.4 0-.724.324-.724.724v5.552H1.448V7A.724.724 0 1 0 0 7v5.793C0 13.46.54 14 1.207 14h11.586C13.46 14 14 13.46 14 12.793V7c0-.4-.324-.724-.724-.724z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload.e6eed8b8.svg";
export { ForwardRef as ReactComponent };